import React from 'react'
import footerFacebook from '../Image/Footer-Facebook.svg'
import footerInstagram from '../Image/Footer-Instagram.svg'
import footerGoogle from '../Image/Footer-Google.svg'
import footerLinkdin from '../Image/Footer-Linkdin.svg'
import footerYoutube from '../Image/Footer-Youtube.svg'
import India from '../Image/India.svg'
import Call from '../Image/call.svg'
import Phone from '../Image/Phone.svg'
import Canada from '../Image/Canada.svg'
import Mail from '../Image/Mail.svg'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
  <>
  <footer className="bg-[#1E1E1E] text-white px-4 sm:px-6 py-10 ">
    <div className="container mx-auto flex flex-col sm:flex-row flex-wrap gap-10 justify-between">
      <div className='flex flex-1 min-w-[250px]'>
        <div className="flex w-36 sm:w-48 sm:flex-col mb-4 flex-col gap-4">
          <a href="https://www.facebook.com/kalathiyainfotech" target='_blank'><img src={footerFacebook} alt="Facebook" className="w-5 h-5" /></a>
          <a href="https://www.instagram.com/kalathiya_infotech/" target='_blank'><img src={footerInstagram} alt="Instagram" className="w-5 h-5" /></a>
          <a href="https://www.google.com/search?q=kalathiya+infotech&rlz=1C1GCEA_enIN1018IN1018&oq=Kalathiya+&aqs=chrome.0.69i59l2j69i57j69i59j69i60l4.17467j0j7&sourceid=chrome&ie=UTF-8" target='_blank'><img src={footerGoogle} alt="Google" className="w-5 h-5" /></a>
          <a href="https://www.linkedin.com/company/kalathiyainfotech/" target='_blank'><img src={footerLinkdin} alt="LinkedIn" className="w-5 h-5" /></a>
          <a href="https://www.youtube.com/@KalathiyaInfotech" target='_blank'><img src={footerYoutube} alt="YouTube" className="w-5 h-5" /></a>
        </div>
        <div>
          <h2 className="text-purple-600 font-bold text-xl">KALATHIYA <span className="text-white font-normal">INFOTECH</span></h2>
          <p className="mt-4 text-sm text-gray-300 leading-relaxed">KALATHIYA Infotech leverages a diverse skill set to deliver tailored solutions, driving success in every endeavor. With a focus on innovation and customer satisfaction.</p>
        </div>
      </div>
      <div className="flex-1 min-w-[250px]">
        <h3 className="text-lg font-semibold mb-4">Quick Link</h3>
        <ul className="space-y-2 text-sm text-gray-300">
          <li><a href="#" className="hover:text-white">Hire Dedicated Development</a></li>
          <li><a href="/service/mobile" className="hover:text-white">Mobile Application Development</a></li>
          <li><a href="/service/web" className="hover:text-white">Web Development</a></li>
          <li><a href="/" className="hover:text-white">Home</a></li>
          <li><a href="/service/web" className="hover:text-white">Services</a></li>
        </ul>
      </div>
      <div className="flex-1 min-w-[250px]">
        <h3 className="text-lg font-semibold mb-4 flex items-center space-x-2">
          <img src={India} alt="India" className="w-5 h-5" />
          <span>India</span>
        </h3>
        <p className="text-sm text-gray-300 mb-2 flex items-center space-x-2">
          <a href="tel:+91 93288 81036" className='cursor-pointer'><img src={Phone} alt="Phone" className="w-5 h-5" /></a>
          <a href="tel:+91 93288 81036" className='cursor-pointer'><span>+91 93288 81036</span></a>
        </p>
        <a href="https://www.google.com/maps/place/Kalathiya+Infotech/@21.2057926,72.8818075,132m/data=!3m1!1e3!4m9!1m2!2m1!1s102-103+Silver+Point,+Jivanjyot+Circle,+Nr+Yogi+chowk+Road+Surat+-395010!3m5!1s0x26cb5e4230fc8877:0xd36ccfe485cd6a01!8m2!3d21.2058961!4d72.8817848!16s%2Fg%2F11kbyh9bk6?entry=ttu&g_ep=EgoyMDI1MDcyOC4wIKXMDSoASAFQAw%3D%3D" target='_blank'><p className="text-sm text-gray-300 mb-2">102-103 Silver Point, Jivanjyot Circle,<br />Nr Yogi chowk Road Surat -395010<br />(Head Office)</p></a>
        <a href="https://www.google.com/maps?q=Shyam+Mandir+Rd,+Hukmchand+Nagar,+Althan,+Surat,+Gujarat+395007&ftid=0x3be05203d87284f1:0xc550f071f2d34a38&entry=gps&lucs=,9427364594275312,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304&g_ep=CAISEjI1LjIwLjAuNzU3ODEwNjA5MBgAINeCAypiLDk0MjczNjQ1OTQyNzUzMTIsOTQyMjQ4MjUsOTQyMjcyNDcsOTQyMjcyNDgsOTQyMzExODgsNDcwNzE3MDQsNDcwNjk1MDgsOTQyMTg2NDEsOTQyMDMwMTksNDcwODQzMDRCAklO&skid=aca2d735-7770-49d7-af9b-9483e4f602d0&g_st=iwb" target='_blank'><p className="text-sm text-gray-300">402–405 Astha Shoppers NearBy<br />BhagvanMahavir Collage, Vesu, Surat –395007<br />(Branch)</p></a>
      </div>
      <div className="flex-1 min-w-[250px]">
        <h3 className="text-lg font-semibold mb-4 flex items-center space-x-2">
          <img src={Canada} alt="Canada" className="w-5 h-5" />
          <span>Canada</span>
        </h3>
        <p className="text-sm text-gray-300 mb-2 flex items-center space-x-2">
          <a href="tel:+15198817124" className='cursor-pointer'><img src={Phone} alt="Phone" className="w-5 h-5" /></a>
          <a href="tel:+15198817124" className='cursor-pointer'><span>+1 5198817124</span></a>
        </p>
        <a href="https://www.google.com/maps/place/855+King+St+E+%23210,+Cambridge,+ON+N3H+3P2,+Canada/@43.3946841,-80.3558498,826m/data=!3m2!1e3!4b1!4m5!3m4!1s0x882b89f0377066e3:0x13fe980777df8121!8m2!3d43.3946841!4d-80.3558498?entry=ttu&g_ep=EgoyMDI1MDcyOC4wIKXMDSoASAFQAw%3D%3D" target='_blank'><p className="text-sm text-gray-300 mb-2">855 King Street East, Unit 210<br />Cambridge, ON, Canada (Branch)</p></a>
        <p className="text-sm text-gray-300 flex items-center space-x-2 mt-2">
          <img src={Mail} alt="Email" className="w-5 h-5" />
          <a href='mailto:info@kalathiyainfotech.com'>info@kalathiyainfotech.com</a>
        </p>
      </div>
    </div>
  </footer>
  </>
  )
}

export default Footer
